import { render, staticRenderFns } from "./ArticlePublish.vue?vue&type=template&id=4f687a8a&"
import script from "./ArticlePublish.vue?vue&type=script&lang=js&"
export * from "./ArticlePublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports